import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(256),
});
export const registerSchema = z.object({
    email: z.string().email(),
    password: z.string().min(12).max(256),
    companyName: z.string().min(1).max(200),
});
